import { ArrowRight, Menu, X } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo-coressen-white.svg";
import { marTerms } from "./terms";

const links = [["Lo que escuchamos", "escuchamos"], ["Las etapas", "ruta"], ["Calendario", "calendario"], ["Inversión", "inversion"]];

export default function MarHero() {
  const [open, setOpen] = useState(false);
  return <>
    <nav className="casa-nav" aria-label="Navegación de la propuesta">
      <a href="#inicio" aria-label="Coressen · Inicio"><img src={logo} alt="Coressen" /></a>
      <div className="casa-nav-links">{links.map(([label, id]) => <Button key={id} variant="ghost" asChild><a href={`#${id}`}>{label}</a></Button>)}</div>
      <Button variant="ghost" size="icon" className="casa-menu" aria-label={open ? "Cerrar menú" : "Abrir menú"} aria-expanded={open} onClick={() => setOpen(!open)}>{open ? <X /> : <Menu />}</Button>
      {open && <div className="casa-mobile-links">{links.map(([label, id]) => <Button variant="ghost" asChild key={id}><a href={`#${id}`} onClick={() => setOpen(false)}>{label}</a></Button>)}</div>}
    </nav>
    <header className="band night casa-hero" id="inicio">
      <div className="wrap">
        <p className="eyebrow">CORESSEN CAPITAL™ | FOUNDER</p>
        <p className="casa-project">Mar Talanquer</p>
        <h1>Mar, es momento de que tu marca evolucione al nivel de tu visión.</h1>
        <p className="for">Evolución, posicionamiento y gobernanza estratégica de marca.</p>
        <p className="casa-hero-lead">Definimos tu territorio de posicionamiento, arquitectura de marca y narrativa persuasiva, construyendo un sistema de gobernanza que fortalece tu valor percibido y permite a tu equipo comunicar y tomar decisiones con autonomía y coherencia.</p>
        <Button size="xl" className="casa-discover" asChild><a href="#escuchamos">Descubrir la propuesta <ArrowRight /></a></Button>
      </div>
    </header>
  </>;
}
